const apBrand = (function () {
    let currentIndex = null;
    let wheelObserver = null;
    let anchorTrigger = null;
    let isScrolling = false;
    let isWheelSlides = false;

    const anchorAttr = '[data-scroll-anchor]';
    const anchorSections = document.querySelectorAll(`#MainContent ${anchorAttr}`);
    const inner = document.querySelector('.ap-post__inner');
    const kv = document.querySelector('.ap-section--kv');
    const intro = document.querySelector('.ap-section--intro');
    const videoS = document.querySelector('.ap-section--video');
    const info = document.querySelector('.ap-section--info');
    const pillar = document.querySelector('.ap-section--pillar');
    // const product = document.querySelector(".ap-section--product");
    const end = document.querySelector('.ap-section--end');
    const productClassName = 'ap-section--product';
    const productImgSwipers = [];
    const scrollToOffsetY = 0;

    // 미디어쿼리 체크
    const mm = gsap.matchMedia();
    const options = {
        isMobile: "(max-width: 720px)",
        isDesktop: "(min-width: 721px)",
        isTablet: "(max-width: 1440px) and (orientation: portrait)",
    };

    const isAnchor = function (section) {
        if (section) {
            const dataAnchor = section.dataset.scrollAnchor;
            const dataIgnore = section.dataset.anchorIgnore;
            const dataAnchorAutoTarget = section.dataset.anchorAutoTarget;
            let result = null;

            mm.add(options, (ctx) => {
                ctx.revert();
                const { isMobile, isDesktop, isTablet } = ctx.conditions;
                
                if (dataAnchor && dataAnchor === 'true') {
                    const targetSection = section.querySelector(dataAnchorAutoTarget);
                    const getPos = targetSection && targetSection.getBoundingClientRect();
                    const deviceCheck = (isMobile && dataIgnore === 'mobile') || (isTablet && dataIgnore === 'mobile') || (isDesktop && dataIgnore === 'pc');

                    if (deviceCheck || dataIgnore === 'auto' && Math.trunc(info.offsetHeight) > window.innerHeight) {
                        result = false;
                    } else {
                        result = true;
                    }
                }
            });
            
            return result;
        }
    };

    const isTouchEvt = function (e) {
        return e.touches && e.touches.length > 0;
    };

    const preventScroll = {
        disableObserver: function () {
            if (wheelObserver.isEnabled) {
                wheelObserver.disable();
                
                debugConsole.update();
            }
        },
        enableObserver: function () {
            if (!wheelObserver.isEnabled) {
                wheelObserver.enable();
                
                debugConsole.update();
            }
        }
    }

    const setCurrentIndex = function () {
        anchorSections.forEach((section, index) => {
            anchorTrigger = ScrollTrigger.create({
                trigger: section,
                id: `section${index}`,
                start: `top-=1px top`,
                end: 'bottom top',
                onToggle: (self) => {
                    if (self.isActive) {
                        setToggleObserver(self);

                        debugConsole.update();
                    }
                },
                onUpdate: (self) => {
                    if (self.isActive) {
                        if (currentIndex !== index) {
                            currentIndex = index;
        
                            debugConsole.update();
                        }
                    }
                },
                onRefresh: (self) => {
                    if (self.isActive) {
                        currentIndex = index;
        
                        debugConsole.update();
                    }
                },
                invalidateOnRefresh: true,
                preventOverlaps: true,
                // markers: true

            });
        });
    };

    const setToggleObserver = function(st) {
        if (isScrolling) return;

        if (st.direction === -1) {
            if (!isAnchor(anchorSections[currentIndex])) {
                // wheelObserver 비활성화 - 일반 스크롤로 변경
                preventScroll.disableObserver();
            } else {
                preventScroll.enableObserver();
            }
        } else {
            if (!isAnchor(anchorSections[currentIndex]) || currentIndex === anchorSections.length - 1) {
                // wheelObserver 비활성화 - 일반 스크롤로 변경
                preventScroll.disableObserver();
            } else {
                preventScroll.enableObserver();
            }
        }
    };

    const setAnimateEffect = (function() {
        const createScrollTrigger = function(trigger, start, end, scrub = false, pin = false, animation = null) {
            ScrollTrigger.create({
                trigger,
                start,
                end,
                scrub,
                pin,
                animation,
                toggleActions: 'play pause play reverse',
                invalidateOnRefresh: true,
                // markers:true,
            });
        }
        
        const kvEffect = function() {
            const header = kv.querySelector('.ap-section__header');
            const logo = header.querySelector('.ap-logo');
            const svg = logo.querySelector('svg');
            const path = svg.querySelector('path');
            const title = kv.querySelector('.ap-section__title');

            mm.add(options, (ctx) => {
                ctx.revert();
                const { isMobile } = ctx.conditions;

                gsap.set(kv, { position: 'relative' });
                gsap.set(logo, { zIndex: 1 });

                const tl = gsap
                    .timeline()
                    .to(svg, {
                        scale: isMobile ? 1.6 : 3.76,
                        opacity: 0,
                        duration: 10,
                        ease: 'none',
                        delay: 0,
                        zIndex: 1,
                    })
                    .to(path, { fill: '#fff', duration: 10 }, '<')
                    .fromTo(title, { yPercent: 20, opacity: 0 }, { yPercent: 0, opacity: 1 }, '+=0.1');

                createScrollTrigger(header, "top top", "bottom top", 1, logo, tl);
            });
        }

        const introEffect = function() {
            const body = intro.querySelector('.ap-section__body');
            const h2 = intro.querySelector('.ap-section__title');
            // const videoWrapper = videoS.querySelector('.ap-video__wrapper');
            // const videoEle = videoS.querySelector('.ap-video video');
            // const videoEleMo = videoS.querySelector('.ap-video video.only-mo');

            // const pauseVideo = function(video) {
            //     video.pause();
            //     video.currentTime = 0;
            // };

            // const createST = function(clipPath, videoEle) {
            //     const playAnimation = () => gsap.to(videoWrapper, { clipPath: 'inset(0% round 1px)', ease: 'none' });
            //     const resetClipPath = () => gsap.to(videoWrapper, {clipPath});

            //     gsap.set(videoWrapper, { clipPath });

                
            //     ScrollTrigger.create({
            //         trigger: videoS.querySelector('.ap-video'),
            //         start: 'top-=2px top',
            //         end: 'bottom top',
            //         onLeave: () => pauseVideo(videoEle),
            //         onLeaveBack: () => {
            //             pauseVideo(videoEle);
            //             resetClipPath();
            //         },
            //         onEnter: () => {
            //             videoEle.play();
            //             playAnimation();
            //         },
            //         onEnterBack: () => videoEle.play(),
            //     });
            // }

            gsap.fromTo(h2, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out', scrollTrigger: h2 });

            // mm.add(options, (ctx) => {
            //     ctx.revert();
            //     const { isMobile } = ctx.conditions;

            //     if (isMobile) {
            //         videoEleMo.pause();
            //         createST("inset(10% round 2rem)", videoEleMo);
            //     } else {
            //         createST("inset(30% round 2rem)", videoEle);
            //     }
            // });
        };

        const infoEffect = function() {
            const wrapper = info.querySelectorAll('.ap-section__body');
            const textWrapper = info.querySelector('.ap-text__wrapper');
            const imgBox = info.querySelector('.ap-img');

            ScrollTrigger.matchMedia({
                "(min-width: 1025px)": function(){
                    // ScrollTrigger.getAll().forEach(trigger => trigger.kill());
                    const end = () => `+=${textWrapper.querySelector(".ap-text__inner").scrollHeight} bottom`;
                    createScrollTrigger(textWrapper, "top top", end, false, imgBox, null);
            },
                "(max-width: 1024px)": function(){
                    // ScrollTrigger.getAll().forEach(trigger => trigger.kill());
                    createScrollTrigger(wrapper, "top top", "bottom 80%", false, false, null);
                },
            })
        };

        const pillarEffect = function() {
            const body = pillar.querySelector(".ap-section__body");
            const inner = pillar.querySelector(".ap-section__inner");
            const text = pillar.querySelector(".ap-section__text");

            gsap.set(text, { yPercent: 20, opacity: 0 })
            const tl = gsap.timeline({
                onStart: () => {
                    if (!wheelObserver.isEnabled && isAnchor(pillar.querySelector(anchorAttr))) {
                        scrollToSection(currentIndex + 1);
                    }
                }
            });
            tl.fromTo(inner.querySelector(".ap-img"), { opacity: 1 }, { opacity: 0.3 }, "<").fromTo(text, { yPercent: 20, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<");

            createScrollTrigger(body, "top-=60% top", "bottom top", false, false, tl);
        }

        const endEffect = function() {
            createScrollTrigger(end.querySelector(".ap-section__body"), "top top", "bottom top", null, false, null);
        }

        const onInit = function() {
            kvEffect();
            introEffect();
            pillarEffect();
            infoEffect();
            endEffect();
        }
        
        return {
            init: onInit
        }
    })();
    
    const setProductPillars = function () {
        const onInit = function () {
            const updateContent = function (swiper, slideIdx) {
                const parentEl = swiper.el.closest(`.${productClassName}`);

                if (parentEl) {
                    const linkBtns = parentEl.querySelectorAll('.ap-link');
                    const colorTexts = parentEl.querySelectorAll('.text--colored');
                    const colorClasses = [];
                    let _index = 0;

                    linkBtns.forEach((btn, index) => {
                        if (index === slideIdx) {
                            btn.classList.add('is-active');
                            _index = index;
                        } else {
                            btn.classList.remove('is-active');
                        }

                        colorClasses.push(`color-${index + 1}`);
                    });

                    colorTexts.forEach((text) => {
                        // 타이를 컬러 변경을 위한 class 추가
                        text.classList.remove(...colorClasses);
                        text.classList.add(colorClasses[_index]);
                    });
                }
            };

            const imgSwiper = document.querySelectorAll(`.${productClassName} .swiper`);
            imgSwiper.forEach((swiper, index) => {
                const prdocutImgSwiper = new Swiper(swiper, {
                    speed: 1000,
                    followFinger: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    on: {
                        init: function () {
                            const slideIdx = this.activeIndex;
                            updateContent(this, slideIdx);
                        },
                        slideChange: function () {
                            const slideIdx = this.activeIndex;
                            updateContent(this, slideIdx);

                            setTimeout(() => {
                                if (slideIdx >= 0 && slideIdx <= this.slides.length) {
                                    if (isWheelSlides) {
                                        isWheelSlides = false;
                                    }

                                    debugConsole.update();
                                }
                            }, 500);
                        },
                    },
                });

                swiper.closest(`.${productClassName}`).dataset.productSectionIndex = index; // section index값 세팅
                productImgSwipers.push(prdocutImgSwiper);
            });
        };

        onInit();
    };

    const scrollToSection = function (index) {
        const targetSection = anchorSections[index] || anchorSections[currentIndex];
        let setOffsetObj = { y: targetSection, offsetY: scrollToOffsetY };

        if (isScrolling && !isAnchor(targetSection)) return;
        
         gsap.to(window, {
            duration: 1,
            scrollTo: setOffsetObj,
            ease: 'power2.inOut', // 부드러운 스크롤을 위한 easing
            onStart: () => {
                isScrolling = true;

                debugConsole.update();
            },
            onComplete: () => {
                currentIndex = index;
                isScrolling = false;

                if (!isAnchor(anchorSections[currentIndex]) || currentIndex === anchorSections.length - 1) {
                    // wheelObserver 비활성화 - 일반 스크롤로 변경
                    preventScroll.disableObserver();
                } else {
                    preventScroll.enableObserver();
                }

                debugConsole.update();
            },
        });
    };

    const scrollToPrevSection = function (observer) {
        if (currentIndex >= 0) {
            const currentSection = anchorSections[currentIndex];
            const isProductSection = currentSection && currentSection.classList.contains(productClassName);
            const isSectionInView = Math.trunc(currentSection.getBoundingClientRect().top) < scrollToOffsetY;

            const goPrevSection = function () {
                const prevIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
                
                if (isSectionInView) {
                    scrollToSection(currentIndex);
                } else {
                    scrollToSection(prevIndex);
                }
            };

            if (isProductSection) {
                // product pillars 영역 예외처리
                const dataIndex = Number(currentSection.dataset.productSectionIndex);
                const imgSwiper = currentSection.querySelector('.swiper');
                const linkBtn = currentSection.querySelector('.ap-link.is-active');
                const textContent = currentSection.querySelector('.ap-text__content');

                const changeSlide = function () {
                    if (productImgSwipers[dataIndex].slides.length > 0) {
                        if (isWheelSlides) return;
                        
                        // wheel로 슬라이드 넘기기
                        if (productImgSwipers[dataIndex].isBeginning || isSectionInView) {
                            // 슬라이드 첫번째장일때 다음 섹션으로 이동
                            goPrevSection();
                        } else {
                            // 이전 슬라이드 보기
                            isWheelSlides = true;
                            productImgSwipers[dataIndex].slidePrev(1000, true);
                        }

                        debugConsole.update();
                    }
                };

                if (isAnchor(currentSection)) {
                    changeSlide();
                }
            } else {
                goPrevSection();
            }
        }
    };

    const scrollToNextSection = function (observer) {
        if (currentIndex < anchorSections.length - 1) {
            const currentSection = anchorSections[currentIndex];
            const isProductSection = currentSection && currentSection.classList.contains(productClassName);
            const isSectionInView = Math.trunc(currentSection.getBoundingClientRect().top) < scrollToOffsetY;

            const goNextSection = function () {
                const nextIndex = currentIndex + 1;
                scrollToSection(nextIndex);
            };

            if (isProductSection) {
                // product pillars 영역 예외처리
                const dataIndex = Number(currentSection.dataset.productSectionIndex);
                const imgSwiper = currentSection.querySelector('.swiper');
                const linkBtn = currentSection.querySelector('.ap-link.is-active');
                const textContent = currentSection.querySelector('.ap-text__content');

                const changeSlide = function () {
                    if (productImgSwipers[dataIndex].slides.length > 0) {
                        if (isWheelSlides) return;
                        
                        // wheel로 슬라이드 넘기기
                        if (productImgSwipers[dataIndex].isEnd || isSectionInView) {
                            // 슬라이드 마지막장일때는 다음 섹션으로 이동
                            goNextSection();
                        } else {
                            // 다음 슬라이드 보기
                            isWheelSlides = true;
                            productImgSwipers[dataIndex].slideNext(1000, true);
                        }

                        debugConsole.update();
                    }
                };

                if (isAnchor(currentSection)) {
                    changeSlide();
                }
            } else {
                goNextSection();
            }
        }
    };

    const wheelEvt = function () {
        wheelObserver = ScrollTrigger.observe({
            target: window,
            type: 'wheel,touch,pointer',
            dragMinimum: 30,
            tolerance: 30,
            lockAxis: true, // drag 제한 - 텍스트 선택을 위한 화면 드래그 행위 등 고려
            preventDefault: true,
            onUp: (self) => {
                const e = self.event;

                if (isScrolling) return;

                if (currentIndex !== null) {
                    if (isTouchEvt(e)) {
                        // touch 이벤트 일때는 반대 방향 - mobile only
                        scrollToNextSection(self);
                    } else {
                        scrollToPrevSection(self);
                    }
                    
                    debugConsole.update();
                }
            },
            onDown: (self) => {
                const e = self.event;

                if (isScrolling) return;

                if (currentIndex !== null) {
                    if (isTouchEvt(e)) {
                        // touch 이벤트 일때는 반대 방향 - mobile only
                        scrollToPrevSection(self);
                    } else {
                        if (wheelObserver.isEnabled) {
                            scrollToNextSection(self);
                        }
                    }

                    debugConsole.update();
                }
            }
        });
    };

    // 디버깅용 스크립트
    const debugConsole = (function () {
        let consoleEl = null;

        const onUpdate = function () {
            if (consoleEl) {
                if (consoleEl.querySelector('.log')) {
                    consoleEl.querySelector('.log').textContent = `
                        currentIndex: ${currentIndex} / 
                        isScrolling : ${isScrolling} / 
                        isWheelSlides : ${isWheelSlides} / 
                        wheelObserver.isEnabled : ${wheelObserver && wheelObserver.isEnabled}
                    `;
                }

                if (consoleEl.querySelectorAll('button').length > 0) {
                    consoleEl.querySelectorAll('button').forEach((button, index) => {
                        if (index === currentIndex) {
                            button.classList.add('is-active');
                        } else {
                            button.classList.remove('is-active');
                        }
                    });
                }
            }
        };

        const onInit = function () {
            const newEl = document.createElement('div');
            newEl.classList.add('debug-console');
            document.body.appendChild(newEl);
            consoleEl = document.querySelector('.debug-console');

            if (consoleEl) {
                let html = '';

                html += '<p class="log"></p>';
                anchorSections.forEach((section, index) => {
                    const isActive = index === currentIndex ? 'is-active' : '';
                    html += `<button type="button" onclick="apBrand.toSection(${index})" class="${isActive}">${index}</button>`;
                });
                consoleEl.insertAdjacentHTML('beforeend', html);
                onUpdate();
            }
        };

        return {
            init: onInit,
            update: onUpdate,
        };
    })();

    const onInit = function () {
        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
        
        setAnimateEffect.init();
        setProductPillars();
        wheelEvt();
        setCurrentIndex();
        AOS.init();

        // debugConsole.init(); // 개발 작업용 - 배포시에는 주석 처리
    };

    ScrollTrigger.config({
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize",
        limitCallbacks: true
    });
    
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
            ScrollTrigger.refresh();
            AOS.refresh()
        }, 250);
    });
    
    return {
        init: onInit,
        toSection: scrollToSection,
    };
})();

apBrand.init();